// Silence non-error toasts globally.
// Per user preference: only error toasts should be visible.
// Loading toasts are kept (they're paired with toast.dismiss for in-flight actions).
import { toast } from "sonner";

const noop = () => undefined;

// Replace the default invocation as well (toast("text") shows neutral toasts)
const originalToast = toast;
const wrapped = function (...args) {
  // Silence default neutral toasts
  return undefined;
};
// Copy non-success/info methods through
Object.keys(originalToast).forEach((key) => {
  wrapped[key] = originalToast[key];
});
wrapped.success = noop;
wrapped.info = noop;
wrapped.message = noop;
wrapped.warning = noop; // user said "only error" — warnings are non-errors
// keep: error, loading, dismiss, promise, custom

// Patch the live toast object so all existing imports see the change
toast.success = noop;
toast.info = noop;
toast.message = noop;
toast.warning = noop;

export default wrapped;
